export default __webpack_public_path__ + "static/horademudar-8c6bb2f70ce0adc8d5d2014d17b86f5b.webp";